
import {
  Col,
  Row
} from "react-bootstrap";
import { T } from "react-translator-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { getCDNImage } from "../../globals";
import { Boy, Man, Avatar } from "../../components/Icons";


const PassengerItemResume = ({ checkIn, passenger, linked_checkin_idx = false, idx }) => {
  const _reservation = JSON.parse(passenger.reservation);
  let _name = [
    _reservation?.title,
    _reservation?.firstName,
    _reservation?.lastName,
  ]
    .filter((str) => str && str !== "")
    .join(" ")
    .trim();

  console.log('3012 - checkIn', checkIn)
  const _adults = checkIn.reservation?.adults || checkIn.guestCounts?.adults;

  const _isBoy = idx + 1 > _adults;
  const _age = _isBoy
    ? checkIn.reservation?.childrenAges?.[idx - _adults]
    : -1;

  const renderName = (age) => {
    let res = T("checkin.child");
    if (age) {
      res += ` (${age} ${T("checkin.years")}) `;
    }
    return res;
  }

  return (<Row key={`checkin-resume-passenger${linked_checkin_idx ? `-${linked_checkin_idx}` : ''}-${idx}`} style={{ marginTop: 5 }}>
    <Col xs={12} className="d-flex" style={{ gap: 10 }}>
      <div>
        {passenger.photos?.selfie ? (
          <div
            style={{
              backgroundImage: `url(${getCDNImage(passenger.photos.selfie)})`,
              backgroundPosition: "center",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundColor: "#DDD",
              height: 45,
              width: 45,
              borderRadius: "50%",
            }}
          ></div>
        ) : (
          <div
            style={{
              height: 45,
              width: 45,
              borderRadius: "50%",
              backgroundColor: "#DDD",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fill: "#5b2e5c",
            }}
          >
            <Avatar width={25} height={25} color="white" />
          </div>
        )}
      </div>
      <div className="flex-fill">
        {!passenger.ommited && passenger.name ? (
          <>
            <p className="mb-0 font-size-normal">
              {passenger.surname}, {passenger.name}
              <br />
              {passenger.dniType && (
                <small className="text-muted">
                  {passenger.dniType} {passenger.dni}
                </small>
              )}
            </p>
            <p className="mb-0 text-muted font-size-sm">
              {passenger.gender && T(`checkin.inputs.gender.${passenger.gender}`)} -{" "}
              {passenger.birthday && T("checkin.date-of-birth")}: {passenger.birthday} -{" "}
              {passenger.age && T("checkin.age")}: {passenger.age}
            </p>
          </>
        ) : (
          <>
            {/* Mostrar avatar para ommited */}

            <p className="mb-0">
              {
                passenger.reservation &&
                (passenger.ommited || !passenger.name) &&
                _isBoy && <Boy width={20} height={20} />
              }
              {
                passenger.reservation &&
                (passenger.ommited || !passenger.name) &&
                !_isBoy && <Man width={20} height={20} />
              }
              <span
                className="text-uppercase general-text-sm ml-2"
                style={{ color: "#988460" }}
              >
                {passenger.reservation
                  ? _isBoy
                    ? renderName(_age)
                    : T("checkin.adult")
                  : T("checkin.no.name.yet")}
              </span>
            </p>

            {passenger.ommited && (
              <p className="mb-0 general-text-sm text-info">
                <FontAwesomeIcon
                  icon={faCaretRight}
                  className="text-info"
                />{" "}
                {T("checkin.guest-complete-later")}
              </p>
            )}
          </>
        )}
      </div>
    </Col>
  </Row>)
}

export default PassengerItemResume;